import { withStyles, Theme, Tooltip } from '@material-ui/core';

export const LightTooltip = withStyles((theme: Theme) => ({
    arrow: {
        color: theme.palette.common.white,
        '&::before': {
            // backgroundColor: 'blue',
            boxShadow: theme.shadows[1],
        }
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);
